import React from 'react';
import Imgix from "react-imgix";
import {isMobile} from "../../../../domain/common";
import {SearchResultDocument} from "../interfaces";
import { sendGAEvent } from '../../../../domain/marketing/gtm-provider';
import { useAppSelector } from '../DAL/store';
import { queryStringSafeChars } from '../constants';

interface ISearchItemProps {
    searchResult: SearchResultDocument,
    searchResultImgPath : string,
    searchResultType : string,
    searchResultSvg: any,
    position: number,
    isLast: boolean
}
const SearchItem = (props : ISearchItemProps) => {

    const isMobileScreen = isMobile();
    const parser = new DOMParser();
    const decodedSearchContent = parser.parseFromString(props.searchResult.content, 'text/html').body.textContent;
    const decodedSearchTitle = parser.parseFromString(props.searchResult.title, 'text/html').body.textContent;
    const SearchQuery = useAppSelector((store) => store.SearchQuery);
    let _safeSearchQuery = SearchQuery.replace(queryStringSafeChars,'');

    const sendClickGAEvent = () => {
        // q: {query} | pos: {position} | page: {distinationURL}
        // q: api | pos: 3 | page: /plugins/api-2500
        sendGAEvent('KenticoSearchClick', `q: ${ _safeSearchQuery.toLowerCase()} | pos: ${ props.position  + 1} | page: ${ props.searchResult.urlPath }`);
    };

    return (
        <div className="w-full pt-2">
            <div className="flex items-center justify-center ">
                <a
                    className="md:pr-6 md:w-auto"
                    href={ props.searchResult.urlPath }
                    onClick={ sendClickGAEvent }
                    rel="noreferrer">
                    {props.searchResultImgPath && props.searchResultImgPath.length > 0 &&
                        <Imgix
                            className="p-4 md:p-2"
                            src={ props.searchResultImgPath }
                            width={isMobileScreen ?  120 : 180 }
                            htmlAttributes={{
                                alt: `Image for ${ decodedSearchTitle }`,
                                loading: 'lazy',
                            }}
                            disableQualityByDPR
                        />
                    }
                    {props.searchResultSvg && props.searchResultImgPath.length === 0 &&
                        <div className="flex items-center justify-center" style={{width:`${isMobileScreen ?  "120px" : "180px"}`}}>
                            <div className="w-1/2">{props.searchResultSvg}</div>
                        </div>
                    }
                </a>
                <div className="flex-1">
                    <div className="font-bold text-base md:text-lg p-1">
                        <a
                            className="no-underline text-black"
                            href={ props.searchResult.urlPath }
                            onClick={ sendClickGAEvent }
                            rel="noreferrer">
                            { decodedSearchTitle }
                        </a>
                    </div>
                    <div className="w-full p-1">
                        {props.searchResultType.length > 0 && <div className="border border-blue-200 rounded w-fit px-2 py-0.5">{props.searchResultType}</div>}
                    </div>
                    <div className={`w-full p-1 w-ellipsis w-line-clamp-2`}>
                        {decodedSearchContent}
                    </div>
                    <div className="hidden md:block w-full p-1" >
                        <a
                            href={ props.searchResult.urlPath }
                            onClick={ sendClickGAEvent }
                            rel="noreferrer">
                            { props.searchResult.urlPath.length > 0 ? props.searchResult.urlPath : "" }
                        </a>
                    </div>
                </div>
            </div>

            {!props.isLast && <div className="border-b border-b-gray-600 w-full pt-2"></div>}

        </div>


    )
};

export default SearchItem;